import {Link} from "react-router-dom";
import {BoxArrowUpRight} from "react-bootstrap-icons";
import {adminRoutes} from "../../../utils/routes";


/**
 * Renders a span element displaying an admin group's name and ID, along with a link to the group's details.
 *
 * @param {Object} props - The properties passed to the component.
 * @param {Object} props.group - The group object containing details.
 * @param {string} props.group.name - The name of the group.
 * @param {number} props.group.id - The unique identifier of the group.
 * @return {JSX.Element} A span element containing the group's name, its ID in small text, and a link to the admin group page.
 */
export default function AdminGroupNameSpan({ group }: {
  group: { name: string, id: number }
}) {
  return <span>{group.name}&nbsp;<small className="text-muted">{group.id}</small><Link to={adminRoutes.group(group.id)}><BoxArrowUpRight /></Link></span>;
}
